const base = { viewBox: '0 0 24 24', width: 24, height: 24, 'aria-hidden': true, focusable: 'false' };

export const IconInstagram = (props) => (
  <svg {...base} {...props} fill="none" stroke="currentColor" strokeWidth="1.8">
    <rect x="3" y="3" width="18" height="18" rx="5" />
    <circle cx="12" cy="12" r="4.2" />
    <circle cx="17.3" cy="6.7" r="1.1" fill="currentColor" stroke="none" />
  </svg>
);

export const IconYouTube = (props) => (
  <svg {...base} {...props} fill="currentColor">
    <path d="M21.6 7.2a2.5 2.5 0 0 0-1.8-1.8C18.2 5 12 5 12 5s-6.2 0-7.8.4A2.5 2.5 0 0 0 2.4 7.2C2 8.8 2 12 2 12s0 3.2.4 4.8a2.5 2.5 0 0 0 1.8 1.8C5.8 19 12 19 12 19s6.2 0 7.8-.4a2.5 2.5 0 0 0 1.8-1.8c.4-1.6.4-4.8.4-4.8s0-3.2-.4-4.8ZM10 15V9l5.2 3L10 15Z" />
  </svg>
);

export const IconPlay = (props) => (
  <svg {...base} {...props} fill="currentColor"><path d="M8 5.5v13a1 1 0 0 0 1.5.9l10.6-6.5a1 1 0 0 0 0-1.8L9.5 4.6A1 1 0 0 0 8 5.5Z" /></svg>
);

export const IconStar = (props) => (
  <svg {...base} {...props} fill="currentColor"><polygon points="12.0,1.0 14.0,7.2 19.8,4.2 16.8,10.0 23.0,12.0 16.8,14.0 19.8,19.8 14.0,16.8 12.0,23.0 10.0,16.8 4.2,19.8 7.2,14.0 1.0,12.0 7.2,10.0 4.2,4.2 10.0,7.2" /></svg>
);
